import { render, staticRenderFns } from "./AdsData.vue?vue&type=template&id=1419e0f5"
import script from "./AdsData.vue?vue&type=script&lang=js"
export * from "./AdsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports